module.exports = __webpack_public_path__ + "assets/img/overdue .77ba097c.png";